<template>
  <div v-if="visible">
    <div
      class="fixed top-0 left-0 z-60 flex h-screen w-screen items-center justify-center bg-black-dark/40 p-4 backdrop-blur-xs"
      @click="close"
    >
      <KekkleCard
        class="max-h-3/4 w-full max-w-md overflow-y-scroll shadow-teal-hard-sm dark:text-slate-200"
        @click.stop
      >
        <div @click.stop>
          <slot></slot>
        </div>
      </KekkleCard>
    </div>
  </div>
</template>
<script>
import KekkleCard from "@/components/ui/KekkleCard.vue";

export default {
  name: "SimpleModal",
  components: { KekkleCard },
  props: {
    visible: Boolean,
  },
  emits: ["close"],
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
